import { User } from '../models/user';

/** Cyflare's own organization; its admins are internal staff. */
export const CYFLARE_ORG_ID = 1;

/** True for internal Cyflare admins (admin group in org 1). Partner admins are not internal. */
export function isCyflareAdmin(user: User | null | undefined): boolean {
  return !!user?.groups?.includes('admin') && user?.primary_organization?.id === CYFLARE_ORG_ID;
}
